export const defaultFontFamily = lang => {
  if (lang === 'zh-Hant') {
    return "'Inter', 'Microsoft YaHei', 微软雅黑, STXihei, 华文细黑"
  }
  return "'Inter', sans-serif"
}
